import { render, staticRenderFns } from "./ExamModalNew.vue?vue&type=template&id=7b15b891&"
import script from "./ExamModalNew.vue?vue&type=script&lang=ts&"
export * from "./ExamModalNew.vue?vue&type=script&lang=ts&"
import style0 from "./ExamModalNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports